let state = function() {
  return {
    showResellerModal: false,
    product: null,
  };
};

const getters = {
  displayResellerModal(state) {
    return state.showResellerModal;
  },
  getResellerProduct(state) {
    return state.product;
  },
};

const mutations = {
  toggleResellerModal(state) {
    state.showResellerModal = !state.showResellerModal;
  },
  turnResellerModalOn(state) {
    state.showResellerModal = true;
  },
  turnResellerModalOff(state) {
    state.showResellerModal = false;
  },
  setResellerProduct(state, product) {
    state.product = product
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/reseller-modal.js